import { createWebPage } from "../../../api/webpage/pages";
import { PMButton } from "../../utils/PMButton";
import { PMDialog } from "../../utils/PMDialog";
import { PMField } from "../../utils/PMField";
import { PMForm } from "../../utils/PMForm";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import toast from "react-hot-toast";

export const CreateWebpageDialog = ({ open, onClose }) => {
  const navigate = useNavigate();
  
  const initialValues = {
    id: null,
    title: "",
  };

  const requiredFields = [
    {
      field: "title",
      validation: Yup.string().required("Title is required"),
    },
  ];

  const formContent = (formik) => {
    return (
      <div className="w-full">
        <div>
          <PMField name="title" label="Title" {...formik} />
        </div>

        <div className="mt-10">
          <PMButton type="buton" onClick={() => formik.submitForm()}>
            Lagre
          </PMButton>
        </div>
      </div>
    );
  };

  const createFunction = {
    type: "axios",
    function: async (values) => {
      try {
        const response = await createWebPage(values);
        // API returns web_page directly in response.data
        const webPage = response?.data;
        if (webPage && (webPage.slug || webPage.id)) {
          const slug = webPage.slug || webPage.id.toString();
          toast.success("Side opprettet!");
          onClose();
          // Navigate after a short delay to ensure state is updated
          setTimeout(() => {
            navigate(`/dashboard/webpage/pages/${slug}`);
          }, 100);
        } else {
          console.error("Invalid response from createWebPage:", response);
          toast.error("Side opprettet, men kunne ikke navigere til editor");
        }
        return response;
      } catch (error) {
        console.error("Error creating webpage:", error);
        toast.error("Kunne ikke opprette side");
        throw error;
      }
    },
  };

  return (
    <PMDialog open={open} onClose={onClose} title="Create webpage">
      <div>
        <PMForm
          name="web_page"
          initialValues={initialValues}
          requiredFields={requiredFields}
          content={formContent}
          createFunction={createFunction}
        />
      </div>
    </PMDialog>
  );
};
